"use strict";

var marko_template = module.exports = require("marko/dist/vdom").t(),
    components_registry_browser = require("marko/dist/runtime/components/registry-browser"),
    marko_registerComponent = components_registry_browser.r,
    marko_componentType = marko_registerComponent("/MP.WEB$2.0/src/views/smoothy~1.0/pages/Classroom/Learner/components/Course/components/ProgramSummary.marko", function() {
      return module.exports;
    }),
    marko_renderer = require("marko/dist/runtime/components/renderer"),
    marko_defineComponent = require("marko/dist/runtime/components/defineComponent"),
    Locale_template = require("../../../../../../../components/Locale/index.marko"),
    marko_loadTag = require("marko/dist/runtime/helpers/load-tag"),
    Locale_tag = marko_loadTag(Locale_template),
    Schedules_template = require("../../../../../../components/Schedules.marko"),
    Schedules_tag = marko_loadTag(Schedules_template),
    Image_template = require("../../../../../../../components/Image/index.marko"),
    Image_tag = marko_loadTag(Image_template),
    Bx_template = require("../../../../../../../components/Bx/index.marko"),
    Bx_tag = marko_loadTag(Bx_template),
    Row_template = require("../../../../../../../components/Row/index.marko"),
    Row_tag = marko_loadTag(Row_template),
    route_link_template = require("marko-router5/src/components/route-link/index.marko"),
    route_link_tag = marko_loadTag(route_link_template),
    marko_forOf = require("marko/dist/runtime/helpers/for-of"),
    IssuedCertificate_template = require("../../../../../../components/IssuedCertificate.marko"),
    IssuedCertificate_tag = marko_loadTag(IssuedCertificate_template),
    WSAdapt_template = require("../../../../../../../components/WSAdapt/index.marko"),
    WSAdapt_tag = marko_loadTag(WSAdapt_template),
    AutoScroll_template = require("marko-perfect-scrollbar/index.marko"),
    AutoScroll_tag = marko_loadTag(AutoScroll_template),
    marko_attrs0 = {
        "class": "p-3"
      },
    marko_createElement = require("marko/dist/runtime/vdom/helpers/v-element"),
    marko_const = require("marko/dist/runtime/vdom/helpers/const"),
    marko_const_nextId = marko_const("aebf92"),
    marko_node0 = marko_createElement("br", null, "34", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs1 = {
        "class": "font-medium-2"
      },
    marko_node1 = marko_createElement("br", null, "39", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs2 = {
        "class": "font-medium-3"
      },
    marko_attrs3 = {
        "class": "text-primary"
      },
    marko_attrs4 = {
        "class": "blue-grey-text"
      },
    marko_attrs5 = {
        "class": "card-text mt-2 pr-6"
      },
    marko_node2 = marko_createElement("br", null, "16", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs6 = {
        "class": "font-medium-3"
      },
    marko_node3 = marko_createElement("br", null, "24", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node4 = marko_createElement("br", null, "26", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_node5 = marko_createElement("hr", null, "27", null, 0, 0, {
        i: marko_const_nextId()
      }),
    marko_attrs7 = {
        "class": "font-medium-2"
      };

function getStats( list, stats ){

  if( !Array.isArray( list ) ) return stats

  list.map( ({ type, duration }) => {
    switch( type ){
      case 'exam': stats.exams++; break
    }

    stats.courses++
  } )

  return stats
};

function render(input, out, __component, component, state) {
  var data = input;

  const user = GState.get('user')

  AutoScroll_tag({
      height: "100vh",
      class: "classroom-info position-absolute zindex-4 top-0 w-100 theme-bg animated slideInUp faster",
      renderBody: function(out) {
        out.be("div", marko_attrs0, "1", component);

        Row_tag({
            col: [
                {
                    renderBody: function(out) {
                      out.be("div", marko_attrs2, "4", component);

                      Locale_tag({
                          renderBody: function(out) {
                            out.t("Your hardwork and persistency has earned you ");
                          }
                        }, out, __component, "5");

                      out.ee();

                      out.be("div", null, "6", component);

                      out.be("h4", null, "7", component);

                      out.e("span", marko_attrs3, "8", component, 1)
                        .t(input.program.name, component);

                      out.t(" ");

                      Locale_tag({
                          text: "Program"
                        }, out, __component, "9");

                      out.ee();

                      out.be("div", marko_attrs4, "10", component);

                      out.be("p", marko_attrs5, "11", component);

                      const { courses, exams } = getStats( input.program.outlines, { courses: 0, exams: 0 } )

                      if (courses) {
                        out.be("div", null, "12", component);

                        out.t(courses, component);

                        out.t(" ");

                        Locale_tag({
                            text: "courses"
                          }, out, __component, "13");

                        out.ee();
                      }

                      if (exams) {
                        out.be("div", null, "14", component);

                        out.t(exams, component);

                        out.t(" ");

                        Locale_tag({
                            text: "exams"
                          }, out, __component, "15");

                        out.ee();
                      }

                      out.ee();

                      out.n(marko_node2, component);

                      out.be("p", marko_attrs6, "17", component);

                      Locale_tag({
                          text: "Congratulation"
                        }, out, __component, "18");

                      out.t(" ");

                      out.t(user.first_name, component);

                      out.t(" ");

                      Locale_tag({
                          renderBody: function(out) {
                            out.t("on this achievement.");
                          }
                        }, out, __component, "19");

                      out.ee();

                      out.ee();

                      Schedules_tag({
                          list: input.dates
                        }, out, __component, "20");

                      out.ee();
                    }
                  },
                {
                    class: "col-3 text-center",
                    renderBody: function(out) {
                      out.be("div", null, "22", component);

                      Image_tag({
                          alt: "Image",
                          src: user.photo,
                          style: "width:80px;height:80px",
                          class: "avatar"
                        }, out, __component, "23");

                      out.ee();

                      out.n(marko_node3, component);

                      Bx_tag({
                          type: "award",
                          class: "font-large-3"
                        }, out, __component, "25");
                    }
                  }
              ]
          }, out, __component, "2");

        if (Array.isArray(input.certificates) && input.certificates.length) {
          out.n(marko_node4, component);

          out.n(marko_node5, component);

          out.be("h5", marko_attrs7, "28", component);

          Locale_tag({
              text: "Certificates"
            }, out, __component, "29");

          route_link_tag({
              href: "/achievements",
              class: "float-right",
              renderBody: function(out) {
                Locale_tag({
                    text: "View Achievements"
                  }, out, __component, "31");
              }
            }, out, __component, "30");

          out.ee();

          Row_tag({
              renderBody: function(out) {
                var $for$0 = 0;

                marko_forOf(input.certificates, function(certificate, index) {
                  var $keyScope$0 = "[" + (($for$0++) + "]");

                  WSAdapt_tag({
                      ns: "col-2",
                      hs: "col-6",
                      qs: "col-3",
                      renderBody: function(out) {
                        IssuedCertificate_tag({
                            certificate: certificate,
                            actions: [
                                "view"
                              ]
                          }, out, __component, "33" + $keyScope$0);
                      }
                    }, out, __component, index);
                });
              }
            }, out, __component, "32");
        }

        out.n(marko_node0, component);

        out.be("p", marko_attrs1, "35", component);

        Locale_tag({
            renderBody: function(out) {
              out.t("Learning doesn't stop here. Explore more ");
            }
          }, out, __component, "36");

        route_link_tag({
            renderBody: function(out) {
              Locale_tag({
                  renderBody: function(out) {
                    out.t("course & programs");
                  }
                }, out, __component, "38");
            }
          }, out, __component, "37");

        out.ee();

        out.n(marko_node1, component);

        route_link_tag({
            href: "/dashboard",
            class: "btn btn-secondary btn-lg m-25",
            renderBody: function(out) {
              Bx_tag({
                  type: "arrow-back",
                  class: "font-medium-5 float-left"
                }, out, __component, "41");

              Locale_tag({
                  text: "Back to dashboard"
                }, out, __component, "42");
            }
          }, out, __component, "40");

        out.ee();
      }
    }, out, __component, "0");
}

marko_template._ = marko_renderer(render, {
    d_: true,
    e_: marko_componentType
  });

marko_template.Component = marko_defineComponent({}, marko_template._);
